import { useMutation } from '@tanstack/react-query';

import { getFaireVersementJustificatifsSauvegarder } from '@/services/getFaireVersementJustificatifsSauvegarder/getFaireVersementJustificatifsSauvegarder';
import { log } from '@/utils/functions/logger/logger';

export const useFaireVersementJustificatifsSauvegarder = () => {
  return useMutation({
    mutationFn: getFaireVersementJustificatifsSauvegarder,
    onError: (error) => {
      log.error(`useFaireVersementJustificatifsSauvegarder failed: ${error}`);
    },
  });
};
